import { AuditEngagementVariant } from "PFApp/components/card_tx/card_variants/audit_engagement_variant";
import { AuditRoleVariant } from "PFApp/components/card_tx/card_variants/audit_role_variant";
import { DefaultVariant } from "PFApp/components/card_tx/card_variants/default_variant";
import { EngagementVariant } from "PFApp/components/card_tx/card_variants/engagement_variant";
import { EventVariant } from "PFApp/components/card_tx/card_variants/event_variant";
import { LessonVariant } from "PFApp/components/card_tx/card_variants/lesson_variant";
import { PositionVariant } from "PFApp/components/card_tx/card_variants/position_variant";
import { PostVariant } from "PFApp/components/card_tx/card_variants/post_variant";
import { QuestionSuggestionVariant } from "PFApp/components/card_tx/card_variants/question_suggestion_variant";
import { RoleVariant } from "PFApp/components/card_tx/card_variants/role_variant";
import { ActivityType } from "PFApp/components/card_tx/header/activity_type_badge";
import { Activity } from "PFTypes";
import { ReactElement } from "react";

export type CardTxContentProps = {
  activity: Activity;
  type: ActivityType;
  isDraft: boolean;
  isFeed?: boolean;
  numberOfRoles?: number;
  isHotVisible?: boolean;
  interestedIn?: number;
  handleShare?: (id: number) => void;
  handleEditPost?: (activityId: number) => void;
  handleHeaderClick?: () => void;
  handleRefetchActivities?: () => void;
};

const CARD_TX_VARIANTS: Record<string, (props: CardTxContentProps) => ReactElement> = {
  post: PostVariant,
  role: RoleVariant,
  audit_role: AuditRoleVariant,
  engagement: EngagementVariant,
  audit_engagement: AuditEngagementVariant,
  suggestion: QuestionSuggestionVariant,
  question: QuestionSuggestionVariant,
  event: EventVariant,
  position: PositionVariant,
  project: PositionVariant,
  lesson: LessonVariant
};

export const CardTxContent = (props: CardTxContentProps) => {
  const Variant = CARD_TX_VARIANTS[props.type.key] ?? DefaultVariant;
  return <Variant {...props} />;
};
